import { render, staticRenderFns } from "./DetailOverview.vue?vue&type=template&id=2731fa4a&scoped=true"
import script from "./DetailOverview.vue?vue&type=script&lang=js"
export * from "./DetailOverview.vue?vue&type=script&lang=js"
import style0 from "./DetailOverview.vue?vue&type=style&index=0&id=2731fa4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2731fa4a",
  null
  
)

export default component.exports